export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-a5c4db5dfca5e9f19d81665d3f5cf586.png";